function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/** @module components/FolderSelector */
import React, { Fragment } from "react";
import ReactDOM from "react-dom";
import { observer, Observer, inject, Provider } from "mobx-react";
import AIOTree, { Spin } from "react-aiot";
import { Modal } from "./";
import Breadcrumb from "./Breadcrumb";
import { i18n, resolveIcon } from "../util";
import { BasicStore, createAllNode, createUnorganizedNode } from "../store";
import rmlOpts from "rmlopts";
import classNames from "classnames";
import $ from "jquery";
var FolderSelector = (_dec = inject("tree"), _dec(_class = observer(_class = (_temp = _class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(FolderSelector, _React$Component);

  var _super = _createSuper(FolderSelector);

  function FolderSelector(_ref) {
    var _this;

    var input = _ref.input,
        disabled = _ref.disabled,
        selected = _ref.selected;

    _classCallCheck(this, FolderSelector);

    _this = _super.apply(this, arguments);

    _this.getInputValue = function () {
      var val = _this.inputObject.value;
      return val === "" || val === "all" ? "" : +val;
    };

    _this.getMainStore = function () {
      return (
        /* global rml */
        rml.store.tree.length && rml.store
      );
    };

    _this.onTreeNodeRender = function (createTreeNode, TreeNode, node) {
      return /*#__PURE__*/React.createElement(Observer, {
        key: node.id
      }, function () {
        return createTreeNode(node);
      });
    };

    _this.onTreeNodeRenderIcon = function (icon) {
      return resolveIcon(icon);
    };

    _this.handleSelect = function (id) {
      var item;

      var previousValue = _this.getInputValue();

      if (id === "") {
        // nullable
        item = _this.props.tree.selected;
        item && item.setter(function (node) {
          return node.selected = false;
        });

        _this.props.tree.setter(function (t) {
          return t.selectedId = undefined;
        }); // Reset manually cause it can not listen when importing from snapshot


        item = null;
      } else {
        item = _this.props.tree.getTreeItemById(id, false);

        if (!item) {
          return _this.handleSelect(+rmlOpts.others.rootId);
        } else {
          item.setter(function (node) {
            return node.selected = true;
          });
        }
      }

      _this.inputObject.value = id;
      $(_this.inputObject).data("node", item).trigger("folderSelected");

      _this.setState({
        visible: false
      });

      previousValue !== id && _this.props.onSelect && _this.props.onSelect(item, _this.inputObject);
      return item;
    };

    _this.handleVisibleChange = function () {
      var visible = !_this.state.visible;

      if (_this._nullableNextVisibleChange) {
        visible = false;
      }

      _this.setState({
        visible: visible
      });

      _this._nullableNextVisibleChange = false;
    };

    _this.handleSelectNull = function () {
      _this._nullableNextVisibleChange = true;

      _this.handleSelect("");
    };

    _this.inputObject = input || document.createElement("input"); // Initial selection

    selected !== undefined && (_this.inputObject.value = selected);
    _this.state = {
      isTreeBusy: false,
      visible: false,
      disabled: (disabled ? ("" + disabled).split(",") : []).map(function (i) {
        return +i;
      })
    };
    return _this;
  }
  /**
   * Set the selected id to the input field so it can be updated through the properties.
   */


  _createClass(FolderSelector, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          input = _this$props.input,
          selected = _this$props.selected;

      if (!input && selected !== prevProps.selected) {
        this.handleSelect(prevProps.selected);
      }
    }
    /**
     * Initially set the value of the input field and breadcrumb path.
     *
     * @internal
     */

  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var val, _this$props2, tree, onFetchTree, mainStore, disabled, fnDisabled, item;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                val = this.getInputValue(), _this$props2 = this.props, tree = _this$props2.tree, onFetchTree = _this$props2.onFetchTree;

                if (!this.props.nullable && (!val || val < 0)) {
                  this.inputObject.value = -1;
                }

                this.setState({
                  isTreeBusy: true
                });

                if (!this.props.fetch) {
                  _context.next = 18;
                  break;
                }

                _context.prev = 4;
                // Check if global rml store holds already a tree
                mainStore = this.getMainStore();

                if (!mainStore) {
                  _context.next = 10;
                  break;
                }

                tree.setTree(mainStore.getTreeSnapshot(), false, mainStore.slugs);
                _context.next = 12;
                break;

              case 10:
                _context.next = 12;
                return tree.fetchTree();

              case 12:
                onFetchTree && onFetchTree(tree);
                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](4);
                console.log(_context.t0);

              case 18:
                // Disable nodes
                disabled = this.state.disabled;

                if (disabled.length) {
                  fnDisabled = function fnDisabled(node) {
                    if (disabled.indexOf(node.properties && +node.properties.type) > -1) {
                      node.setter(function (n) {
                        return n.className = "rml-deactivated";
                      });
                    }
                  };

                  tree.nodes(fnDisabled);
                  tree.nodes(fnDisabled, true);
                } // Modify this tree


                this.setState({
                  isTreeBusy: false
                }); // Preselect

                item = this.handleSelect(val);
                this.props.onNodeInit && this.props.onNodeInit(item, this.inputObject);

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 15]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          isTreeBusy = _this$state.isTreeBusy,
          visible = _this$state.visible,
          _this$props3 = this.props,
          className = _this$props3.className,
          style = _this$props3.style,
          editable = _this$props3.editable,
          title = _this$props3.title,
          nullable = _this$props3.nullable,
          _this$props3$tree = _this$props3.tree,
          breadcrumb = _this$props3$tree.breadcrumb,
          selected = _this$props3$tree.selected,
          staticTree = _this$props3$tree.staticTree,
          tree = _this$props3$tree.tree,
          ignoreChildNodes = _this$props3.ignoreChildNodes,
          children = _this$props3.children,
          before = _this$props3.before,
          after = _this$props3.after;
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Modal, {
        key: "modal",
        visible: visible && editable,
        wrapClassName: "rml-folder-selector",
        okText: i18n("ok"),
        cancelText: i18n("cancel"),
        title: title,
        onCancel: this.handleVisibleChange
      }, /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(AIOTree, _extends({
        rootId: +rmlOpts.others.rootId,
        staticTree: staticTree.filter(function (_ref2) {
          var id = _ref2.id;
          return id !== "all";
        }),
        tree: tree.length > 0 ? tree : [],
        isResizable: false,
        isFullWidth: true,
        creatable: {
          buttons: {}
        },
        toolbar: {
          buttons: {}
        },
        onSelect: this.handleSelect,
        renderItem: this.onTreeNodeRender,
        renderIcon: this.onTreeNodeRenderIcon,
        headline: /*#__PURE__*/React.createElement("span", {
          style: {
            paddingRight: 5
          }
        }, i18n("folders")),
        noFoldersTitle: i18n("noFoldersTitle"),
        ignoreChildNodes: ignoreChildNodes,
        noFoldersDescription: "",
        noSearchResult: i18n("noSearchResult"),
        theme: "wordpress",
        autoFocusSearchInput: true
      }, this.state)), children)), before, /*#__PURE__*/React.createElement("div", {
        key: "breadcrumb",
        className: classNames("rml-folder-edit", className, {
          "rml-deactivated": !editable
        }),
        style: style,
        onClick: this.handleVisibleChange
      }, /*#__PURE__*/React.createElement(Spin, {
        spinning: isTreeBusy
      }, /*#__PURE__*/React.createElement(Breadcrumb, {
        path: breadcrumb,
        closeable: selected && editable && nullable,
        onClose: this.handleSelectNull
      }))), after);
    }
  }]);

  return FolderSelector;
}(React.Component), _class2.defaultProps = {
  fetch: true,
  // Set to false if you want to set the selectable tree by yourself (store)
  nullable: false,
  editable: true,
  onSelect: undefined,
  onNodeInit: undefined,
  onFetchTree: undefined,
  ignoreChildNodes: false,
  before: undefined,
  after: undefined,
  title: undefined,
  selected: undefined,
  // Use this only without input
  input: undefined,
  // Input is optional, use selected for initial selected id
  disabled: "" // comma seperated list of types which are disabled

}, _temp)) || _class) || _class);
export { FolderSelector };
/**
 * Create the folder selector in a given target.
 *
 * @param {HTMLElement} target
 * @param {HTMLElement} input An input where the selected id is stored (usually input[type="hidden"])
 * @param {object} props The properties for FolderSelector control
 * @param {object} store
 * @returns {object} The created store
 */

export default function createFolderSelector(target, input, props, useStore) {
  var store = useStore || BasicStore.create({
    staticTree: [_objectSpread(_objectSpread({}, createAllNode()), {}, {
      $visible: false
    }), createUnorganizedNode()]
  });
  ReactDOM.render( /*#__PURE__*/React.createElement(Provider, {
    tree: store
  }, /*#__PURE__*/React.createElement(FolderSelector, _extends({
    input: input
  }, props))), target);
  return store;
}